import { utils } from "@intrasync/utils";

export const builtInServices = [
  "app-version",
  "log",
  "refresh-token",
  "user-feedback",
  "user-permissions",
  "user",
  "user-subscription",
  "email/activate-user",
  "email/login",
  "email/password-reset",
  "email/password-reset-verification",
  "refresh-token",
  "project",
];

export const builtInServiceStores = builtInServices.map((service) =>
  utils.servicePathToStoreName(service)
);

const builtInStores = [
  "appLayoutStore",
  "authStore",
  "authRedirectStore",
  "barcodeCameraStore",
  "channelStore",
  "connectionStore",
  "dataGridStore",
  "findAllStore",
  "notificationStore",
  "registrationStore",
  "requestQueueStore",
  "rootStore",
  "routerStore",
  "serviceStore",
  "viewStore",
  "webApiStore",
  "themeStore",
  "scheduleGridStore",
  "signaturePadStore",
  ...builtInServiceStores,
];

export default builtInStores;
